<template>
  <a :href="link" :target="target" class="btn btn-arrow btn-sm"
    >{{ label }}<span class="arrow"><span class="arrow-inner"></span></span
  ></a>
</template>

<script>
export default {
  name: "Button",
  props: {
    link: String,
    postType: String,
  },
  computed: {
    label: function () {
      return this.$store.getters.getLinkLabel(this.postType);
    },
    target: function () {
      let target = "";

      if (this.postType == "training") {
        target = "_blank";
      }

      return target;
    },
  },
};
</script>
